import { Action, Reducer } from "redux";
import { SofView } from "../models";

export interface SofViewState {
  sofView: SofView;
}

export const defaultState = {
  sofView: SofView.None
};

export interface SetSofViewAction {
  type: "CHANGE_SOF_VIEW";
  view: SofView;
}

export const actionCreators = {
  setSofView: (view: SofView) => ({ type: "CHANGE_SOF_VIEW", view })
};

export const reducers: Reducer<SofViewState> = (
  state: SofViewState | undefined,
  incomingAction: Action
): SofViewState => {
  if (state === undefined) {
    return defaultState;
  }

  const action = incomingAction as SetSofViewAction;
  switch (action.type) {
    case "CHANGE_SOF_VIEW":
      return { sofView: action.view };
    default:
      return state;
  }
};
